import { CharacterSection } from './CharacterSection'
import { withCharacterSection } from './withCharacterSection'

const ConnectedCharacterSection = withCharacterSection(CharacterSection)
export { ConnectedCharacterSection as CharacterSection }
